const rows = [{ id: 1, type: 'formaPagamento', nome: 'Forma de pagamento' }];

const tableHeader = ['Forma de pagamento', 'Editar', 'Excluir'];

const Tablecadastro = [
  { id: 'nome', title: 'Forma de pagamento', type: 'text', placeholder: 'Entre com a forma de pagamento...' },
];

const title = 'Cadastro de forma de pagamento';

export const cadastro = {
  title: title,
  cadastro: Tablecadastro,
};

export const table = {
  header: tableHeader,
  type: 'formaPagamento',
  rows: rows,
};
